import { Button, Card, Text } from '@mantine/core'
import { useGetAlertRuleByDevice } from 'api/alertRuleDevice'
import Datatable from 'components/datatable'
import { r } from 'config/routes'
import { TFunction } from 'i18next'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BsFileRuled } from 'react-icons/bs'
import { TbPlus } from 'react-icons/tb'
import { useParams } from 'react-router-dom'
import { TAlertRule } from 'shared/types'
import { Query, TDatatable } from '..'
import { AlertLevelBadge } from './AlertLevelBadge'
import { AssignAlertRuleModal } from './AssignAlertRuleModal'

const headers: (t: TFunction) => TDatatable<TAlertRule>[] = t => [
  {
    id: 'name',
    label: t('generic.name'),
    colSize: 1,
    selector: item => <Text>{item.name}</Text>,
  },
  {
    id: 'level',
    label: t('alert.level'),
    colSize: 1,
    selector: item => <AlertLevelBadge level={item.level} />,
  },
]

export const AlertRuleList = () => {
  const { t } = useTranslation()
  const { deviceId } = useParams()
  const query = useGetAlertRuleByDevice(deviceId)
  const [modalOpened, setModalOpened] = useState(false)

  const assignedIds = useMemo(
    () => (query.isSuccess ? query.data.map(device => device.id) : []),
    [query],
  )

  return (
    <Card>
      <Query.Wrapper query={query}>
        <Query.Data>
          {(data: TAlertRule[]) => (
            <>
              <Datatable
                noShadow
                data={data}
                headers={headers(t)}
                href={item => r['alertRule.edit'](item.id)}
              />
              <Button
                mt="md"
                onClick={() => setModalOpened(true)}
                color="gray"
                leftSection={<TbPlus size={'1.2em'} />}
                variant="light"
                fullWidth
              >
                {t('alert.templateAssign')}
              </Button>
            </>
          )}
        </Query.Data>
        <Query.NoData
          buttonContent={t('alert.templateAdd')}
          icon={BsFileRuled}
          title={t('alert.templatesNoData')}
          onClick={() => setModalOpened(true)}
        />
      </Query.Wrapper>
      <AssignAlertRuleModal
        assignedIds={assignedIds}
        opened={modalOpened}
        setOpened={setModalOpened}
      />
    </Card>
  )
}
